export const KioskState = {
  init: 0,
  ready: 1,
  call: 2,
  rejectedRemote: 3,
  acceptedRemote: 4,
  callCompleted: 5,
  calling: 6,
  terminatedRemote: 7,
  terminatedLocal: 8,
  busy: 9,
  unknownNumber: 10,
  unregisteredNumber: 11,
  wrongUsernamePassword: 12,
  tokenInvalid: 13,
  tokenExpired: 14,
};

export const stateToString = state => {
  const stateStrings = Object.keys(KioskState);

  if (state >= 0 && state < stateStrings.length) {
    return stateStrings[state];
  } else {
    return "Unknown";
  }
};






// WEBPACK FOOTER //
// ./src/kiosk/index.js